import { createFileRoute } from "@tanstack/react-router";
import { ShowroomPage, showroomHeadEn } from "@/pages/ShowroomPage";

export const Route = createFileRoute("/en/showroom")({
  head: showroomHeadEn,
  component: ShowroomPage,
});
